import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FaArrowLeft } from "react-icons/fa6";
import { Alert } from "@mui/material"; // Import the Alert component
import PromotionImage from "./promotionImage";
import ConfirmCard from "./confirmCard/index";
import InformCard from "./informCard";
import Term from "./term";
import FillButton from "../shared/fillButton";
import ConfirmDialog from "./confirmAlert";
import LoadingIndicator from "../shared/loadingIndicator";
import { RootState, AppDispatch } from "../reduxStore/store";
import { fetchCouponDetails } from "../models/sigleCouponSlice";
import { fetchCurrentUser } from "../models/currentUserSlice";
import { purchaseCoupon } from "../models/purchaseSlice";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";


interface LocationState {
  couponId?: string;
}

const PromotionConfirmPage: React.FC = () => {
  const location = useLocation();
  const { couponId } = (location.state as LocationState) || {};
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const coupon = useSelector((state: RootState) => state.singleCoupon.coupon);
  const loading = useSelector((state: RootState) => state.singleCoupon.loading);
  const currentPoints = useSelector(
    (state: RootState) => state.currentUser.user?.points.current_points
  );
  const buyCoupons = useSelector((state: RootState) => state.tranaction.coupons);

  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchCurrentUser()).unwrap();
        if (couponId) {
          console.log("Fetching details for Coupon ID:", couponId);
          await dispatch(fetchCouponDetails(couponId)).unwrap();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [couponId, dispatch]);

  const buyCoupon = async () => {
    try {
      if (couponId) {
        console.log("Purchasing Coupon ID:", couponId);
        await dispatch(purchaseCoupon(couponId)).unwrap();
        navigate("/buycoupon");
      }
    } catch (error) {
      console.error("Error purchasing coupon:", error);
    }
  };

  const handlePurchase = () => {
    if (currentPoints !== undefined && coupon?.points !== undefined) {
      const couponPoints = Number(coupon.points);
      
      if (isNaN(couponPoints)) {
        setErrorMessage("Coupon points are invalid.");
        return;
      }

      if (currentPoints < couponPoints) {
        setErrorMessage("Insufficient points to redeem this coupon.");
        return;
      }
    }
    setOpenConfirmDialog(true);
  };

  const handleConfirm = () => {
    setOpenConfirmDialog(false);
    buyCoupon();
  };

  const handleCancel = () => {
    setOpenConfirmDialog(false);
  };

  return (
    <div className="min-h-screen max-h-screen flex flex-col w-[100%] overflow-x-hidden">
      {loading ? (
        <LoadingIndicator />
      ) : (
        <>
          <div className="w-screen h-1/2 relative">
            <PromotionImage />
            <a href="/homePage">
              <KeyboardArrowLeftIcon className="absolute top-4 left-4 text-black text-xl" />
            </a>
            <div className="absolute top-10 left-0 w-full h-full flex justify-center items-end">
              <ConfirmCard
                title={coupon?.title}
                end_date={coupon?.end_date}
                Points={coupon?.points}
              />
            </div>
          </div>
          <div className="mt-14 w-[98%] flex-col">
            <div className="flex justify-center">
              <InformCard amountOfPoint={currentPoints} />
            </div>
            {/* <div className="flex justify-center flex-grow"> */}
              {/* <Term /> */}
            {/* </div> */}

           <div className="flex justify-center">
            {errorMessage && (
                <Alert severity="error" className="mb-4">
                  {errorMessage}
                </Alert>
              )}
            </div>

            <div className="mt-14 flex justify-center my-4 ">
            
              <FillButton
                name="Redeem"
                disabled={false}
                onClick={handlePurchase}
              />
            </div>
          </div>
          <ConfirmDialog
            open={openConfirmDialog}
            title="Confirm?"
            description="Do you wish to redeem this coupon?"
            onConfirm={handleConfirm}
            onCancel={handleCancel}
          />
        </>
      )}
    </div>
  );
};

export default PromotionConfirmPage;
